// src/utils/gemini.js
import { GoogleGenerativeAI } from "@google/generative-ai";

const API_KEY = process.env.REACT_APP_GEMINI_API_KEY || "";

// Initialize the API client
const genAI = new GoogleGenerativeAI(API_KEY);

/**
 * Basic function to ask Gemini anything.
 */
export async function askGemini(prompt, context = "") {
  if (!API_KEY) {
    throw new Error("Gemini API Key is missing. Please add REACT_APP_GEMINI_API_KEY to your .env file.");
  }

  try {
    const fullPrompt = context ? `${context}\n\nUser Question: ${prompt}` : prompt;
    
    // Using gemini-3-flash-preview (active in 2026)
    const model = genAI.getGenerativeModel({ 
      model: "gemini-3-flash-preview", 
      systemInstruction: "You are 'Life AI', a helpful AI assistant for 'Pankaj Lifewellness' training center. You are an expert in Hindu Panchang, Indian culture, and general health/wellness. Always use the 'LIVE APP CONTEXT' block to answer specific questions about invoices, revenue, or students."
    });
    
    console.log("Gemini Request sent...");
    const result = await model.generateContent(fullPrompt);
    const response = await result.response;
    const text = response.text();
    console.log("Gemini Response received.");
    return text;
  } catch (error) {
    console.error("Gemini API Error:", error);
    throw error;
  }
}

/**
 * Specialized function to get accurate Panchang and Daily Insights.
 */
export async function getDailyInsights(date = new Date(), context = "") {
  const dateStr = date.toLocaleDateString("en-IN", { dateStyle: "full" });
  
  const prompt = `
    You are an expert in Hindu Panchang and Indian culture.
    For the date ${dateStr}, provide the following details in JSON format only:
    {
      "tithi": "Current Tithi Name",
      "paksha": "Shukla or Krishna",
      "month": "Hindu Month Name",
      "samvat": "Vikram Samvat Year",
      "festivals": ["List of festivals today"],
      "thought": "A Hindi thought with English translation",
      "isAuspicious": true
    }
    Return ONLY the JSON object.
  `;

  try {
    const text = await askGemini(prompt, context);
    const cleanedText = text.replace(/```json/g, "").replace(/```/g, "").trim();
    return JSON.parse(cleanedText);
  } catch (error) {
    console.error("Failed to get daily insights:", error);
    return null;
  }
}

/**
 * Generates a clean paragraph for typing practice.
 */
export async function generateTypingContent(topic, language = "english", wordCount = "100") {
  const words = parseInt(wordCount) || 100;
  const prompt = `Generate a typing paragraph on "${topic}" in ${language}. Approx ${words} words. Provide text only.`;
  try {
    return await askGemini(prompt);
  } catch (error) {
    console.error("Failed to generate typing content:", error);
    throw error;
  }
}
